import React, { useEffect, useState } from "react";
import ZbizInput from "../../components/zbizInput/ZbizInput";
import ZDropdown from "../../components/zDropdown/ZDropdown";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { handlePostRequest } from "../../services/PostTemplate";
import { handleGetRequest } from "../../services/GetTemplate";
import { Dropdown } from "primereact/dropdown";
import Monthwise from "./charts/Monthwise";
import Datewise from "./charts/Datewise";
import Narrationwise from "./charts/Narrationwise";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";

const Analytics = () => {
  const companyLoggedIn = localStorage.getItem("companyId");

  const [narrations, setNarrations] = useState([]);
  const [selectedNarration, setSelectedNarration] = useState(null);
  const [loading, setLoading] = useState(false);

  const [totalBatches, setTotalBatches] = useState("");
  const [successData, setSuccessData] = useState("");
  const [failData, setFailData] = useState("");
  const [datewiseData, setDatewiseData] = useState([]);
  const [monthwiseData, setMonthwiseData] = useState([]);
  const [narrationwiseData, setNarrationwiseData] = useState([]);
  // const [transactionData, setTransactionData] = useState([])

  const history = useHistory();

  const validationSchema = Yup.object().shape({
    fromDate: Yup.date()
      .required("From Date is required.")
      .max(Yup.ref("toDate"), "From Date cannot be greater than To Date."),
    toDate: Yup.date()
      .required("To Date is required.")
      .min(Yup.ref("fromDate"), "To Date cannot be lesser than From Date.")
      .test(
        "max-gap",
        "The date range cannot exceed 3 months (92 days).",
        function (value) {
          const { fromDate } = this.parent;
          if (fromDate && value) {
            const from = new Date(fromDate);
            const to = new Date(value);
            const diffInDays = Math.floor((to - from) / (1000 * 60 * 60 * 24));
            return diffInDays <= 92; // Ensure gap is within 92 days
          }
          return true;
        }
      ),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      fromDate: new Date().toISOString().split("T")[0],
      toDate: new Date(new Date().setMonth(new Date().getMonth() + 1))
        .toISOString()
        .split("T")[0],
      companyId: companyLoggedIn !== "null" ? parseInt(companyLoggedIn) : "",
    },
    onSubmit: async (data) => {
      setLoading(true);

      // Clear previous data
      setTotalBatches(null);
      setSuccessData(null);
      setFailData(null);
      setDatewiseData(null);
      setMonthwiseData(null);
      setNarrationwiseData(null);
      // setTransactionData(null);

      data["companyId"] =
        formik.values.companyId == undefined ? "" : formik.values.companyId;
      data["narration"] =
        formik.values.narration == undefined ? "" : formik.values.narration;

      try {
        const results = await Promise.allSettled([
          handlePostRequest(
            { ...data, narration: selectedNarration },
            "zbizgateway/nonFin/totalbatchcount",
            false
          ),
          handlePostRequest(
            { ...data, narration: selectedNarration },
            "zbizgateway/nonFin/countandvolumesuccess",
            false
          ),
          handlePostRequest(
            { ...data, narration: selectedNarration },
            "zbizgateway/nonFin/countandvolumeFailure",
            false
          ),
          handlePostRequest(
            { ...data, narration: selectedNarration },
            "zbizgateway/nonFin/datewisesummary",
            false
          ),
          handlePostRequest(
            { ...data, narration: selectedNarration },
            "zbizgateway/nonFin/monthwisesummary",
            false
          ),
          handlePostRequest(
            { ...data, narration: selectedNarration },
            "zbizgateway/nonFin/narrationwisesummary",
            false
          ),
          // handlePostRequest(data, "zbizgateway/nonFin/transactionsummary", false),
        ]);

        // Track success and failure counts
        let successCount = 0;
        let failureCount = 0;

        results.forEach((result, index) => {
          if (result.status === "fulfilled") {
            successCount++;
            switch (index) {
              case 0:
                setTotalBatches(result.value?.data);
                break;
              case 1:
                setSuccessData(result.value?.data);
                break;
              case 2:
                setFailData(result.value?.data);
                break;
              case 3:
                setDatewiseData(result.value?.data);
                break;
              case 4:
                setMonthwiseData(result.value?.data);
                break;
              case 5:
                setNarrationwiseData(result.value?.data);
                break;
              // case 6:
              //     setTransactionData(result.value?.data);
              //     break;
              default:
                break;
            }
          } else {
            failureCount++;
            console.error(
              `API call ${index + 1} failed:`,
              result?.reason?.response?.data?.messages
            );
          }
        });

        // if (failureCount === 0) {
        //     toast.success("All records fetched successfully.");
        // } else if (successCount === 0) {
        //     toast.error("Failed to fetch records.");
        // } else {
        //     toast.warn(`${successCount} records fetched successfully, ${failureCount} failed.`);
        // }
      } catch (error) {
        console.error("Unexpected error:", error);
        toast.error("An unexpected error occurred. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const props = {
    onChange: formik.handleChange,
    values: formik.values,
    isFormFieldValid: isFormFieldValid,
    getFormErrorMessage: getFormErrorMessage,
  };

  useEffect(() => {
    const getNarrationsLov = async () => {
      try {
        const res = await handleGetRequest("zbizgateway/lov/lovNarration");
        setNarrations(res?.data);
      } catch (error) {
        console.log(error);
      }
    };
    getNarrationsLov();
  }, []);

  useEffect(() => {
    formik.handleSubmit();
  }, []);

  const today = new Date();

  return (
    <>
      <div className="page_header">
        <div
          className="Top__Btn"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="d_align">
            <i
              className="pi pi-arrow-circle-left mr-1"
              onClick={() => history.goBack()}
            />
            <h3 className="mod_heading">Analytics</h3>
          </div>
        </div>
      </div>

      <div
        className="card Card__Round"
        style={{ marginBottom: "6px", borderRadius: "3px" }}
      >
        <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
          <div className="p-grid">
            <div className="p-col-3">
              <div className="input_cp ">
                <ZbizInput
                  type="date"
                  label="From Date"
                  keyName="fromDate"
                  {...props}
                />
              </div>
            </div>
            <div className="p-col-3">
              <div className="input_cp ">
                <ZbizInput
                  type="date"
                  label="To Date"
                  keyName="toDate"
                  max={today.toISOString().split("T")[0]}
                  {...props}
                />
              </div>
            </div>
            <div className="p-col-2">
              <div className=" input_cp">
                <ZDropdown
                  {...props}
                  label="Company"
                  valueOption="companyId"
                  keyName="companyId"
                  placeholder="All"
                  optionLabel="companyName"
                  url="zbizgateway/nonFin/getAllCompanies"
                  disabled={companyLoggedIn === "null" ? false : true}
                />
              </div>
            </div>
            <div className="p-col-2">
              <div className=" input_cp">
                <label htmlFor="narration" className="Label__Text">
                  Narration
                </label>
                <Dropdown
                  id="narration"
                  placeholder="Select"
                  options={narrations}
                  optionLabel="code"
                  optionValue="code"
                  name="narration"
                  value={selectedNarration}
                  onChange={(e) => setSelectedNarration(e?.target?.value)}
                  className="Dropdown__Round"
                  showClear
                />
              </div>
            </div>
            <div className="p-col-2">
              <div
                className="Down__Btn"
                style={{
                  textAlign: "left",
                  display: "inline",
                  lineHeight: "4.5",
                }}
              >
                <Button type="submit" label="Search" className="Btn__Dark" />
              </div>
            </div>
          </div>

          {/* <div className="Down__Btn">
                        <Button type="submit" label="Search" className="Btn__Dark" />
                    </div> */}
        </form>
      </div>

      <section className="stat_cards">
        <div className="p-grid">
          <div className="p-col-4">
            <Card
              title="Total Batch"
              className="card"
              style={{
                borderTop: "3px solid #68aaa5",
                padding: "0px",
                marginBottom: "0",
              }}
            >
              <div>
                Count of Total Batches
                <h3>{totalBatches ?? 0}</h3>
              </div>
            </Card>
          </div>
          <div className="p-col-4">
            <Card
              title="Successful"
              className="card"
              style={{
                borderTop: "3px solid #e74c3c",
                padding: "0px",
                marginBottom: "0",
              }}
            >
              <div className="p-grid">
                <div className="p-col-4">
                  Count
                  <h3>{successData?.count ?? 0}</h3>
                </div>
                <div className="p-col-4">
                  Volumn
                  <h3>{successData?.volume?.toLocaleString() ?? 0}</h3>
                </div>
              </div>
            </Card>
          </div>
          <div className="p-col-4">
            <Card
              title="Failed"
              className="card"
              style={{
                borderTop: "3px solid #52be80",
                padding: "0px",
                marginBottom: "0",
              }}
            >
              <div className="p-grid">
                <div className="p-col-4">
                  Count
                  <h3>{failData?.count ?? 0}</h3>
                </div>
                <div className="p-col-4">
                  Volumn
                  <h3>{failData?.volume?.toLocaleString() ?? 0}</h3>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </section>

      <div className="p-grid">
        <Datewise datewiseData={datewiseData} />

        <Monthwise monthwiseData={monthwiseData} />

        <Narrationwise narrationwiseData={narrationwiseData} />

        {/* <TransactionSummary transactionData={transactionData} /> */}
      </div>
    </>
  );
};

export default Analytics;
